import { Routes } from 'react-router-dom';
import ProtectedRouter from 'infrastructure/routing/ProtectedRouter';
import { Route } from 'framework/routing';
import { useVacancyGroupRoute, VACANCY_GROUP_PATH } from 'domain/recruiting/newVacancy/routing';
import ViewVacancyPublication from './show/publications/Show';
import UpdateVacancyPublication from './show/publications/createupdate/Update';
import CreateVacancyGroupPublication from './show/publications/createupdate/Create';
import {
  RECRUITING_DASHBOARD_READ,
  RECRUITING_VACANCY_GROUP_READ,
  RECRUITING_VACANCY_PUBLICATION_CREATE,
  RECRUITING_VACANCY_PUBLICATION_READ,
  RECRUITING_VACANCY_PUBLICATION_UPDATE,
} from 'domain/shared/newVacancy';
import RecruitingBoard from '../recruitingBoard/List/RecruitingBoard';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import ViewVacancyGroup from './show/vacancyGroup/ViewVacancyGroup';
import VacancyHistoryList from './show/history/List/VacancyHistoryList';
import RelatedPublicationsList from './show/publications/List/RelatedPublicationsList';
import SourcingCandidatesList from './show/sourcing/List/SourcingCandidatesList';
import VacanciesWrapper from './show/vacancy/VacanciesWrapper';
import { GlobalProtectedRoute } from 'framework/authorization';

const VacancyGroupRouter = () => {
  const {
    singleEntityRoute,
    sourcingRoute,
    publicationsRoute,
    createPublicationsRoute,
    updatePublicationRoute,
    publicationRoute,
    historyRoute,
  } = useVacancyGroupRoute();

  const { isFeatureEnabled } = useFeatureToggle();

  const viewNewDashboard = isFeatureEnabled(Features.NEW_RECRUITING_DASHBOARD);

  return (
    <ProtectedRouter basePath={VACANCY_GROUP_PATH}>
      <Routes>
        {viewNewDashboard ? (
          <Route
            path="/new-dashboard"
            element={
              <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_DASHBOARD_READ}>
                <RecruitingBoard />
              </GlobalProtectedRoute>
            }
          />
        ) : (
          <></>
        )}

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_GROUP_READ}>
              <ViewVacancyGroup />
            </GlobalProtectedRoute>
          }
        >
          <Route index element={<VacanciesWrapper />} />
          <Route
            path={publicationsRoute}
            element={
              <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_PUBLICATION_READ}>
                <RelatedPublicationsList />
              </GlobalProtectedRoute>
            }
          />

          <Route
            path={sourcingRoute}
            element={
              <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_GROUP_READ}>
                <SourcingCandidatesList />
              </GlobalProtectedRoute>
            }
          />

          <Route
            path={historyRoute}
            element={
              <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_GROUP_READ}>
                <VacancyHistoryList />
              </GlobalProtectedRoute>
            }
          />
        </Route>

        <Route
          path={publicationRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_PUBLICATION_READ}>
              <ViewVacancyPublication />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={createPublicationsRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_PUBLICATION_CREATE}>
              <CreateVacancyGroupPublication />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={updatePublicationRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={RECRUITING_VACANCY_PUBLICATION_UPDATE}>
              <UpdateVacancyPublication />
            </GlobalProtectedRoute>
          }
        />
      </Routes>
    </ProtectedRouter>
  );
};

VacancyGroupRouter.getRouterPath = () => `${VACANCY_GROUP_PATH}/*`;

export default VacancyGroupRouter;
